/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerAnalyticsConfig } from '../../config/header.config';
export interface IHeaderAnalyticsPluginMethods extends IPluginMethodMap {
  getHeaderAnalyticsSync(args?: any): any;
}

export class HeaderAnalyticsPlugin implements IAgentPlugin {
  readonly methods: IHeaderAnalyticsPluginMethods;

  constructor() {
    this.methods = {
      getHeaderAnalyticsSync: this.getHeaderAnalyticsSync.bind(this),
    };
  }

  getHeaderAnalyticsSync(args?: any) {
    return {
      // error:HeaderAnalyticsConfig
      header: headerAnalyticsConfig,
    };
  }
}
